// -----------------------------------------------------------------------------
// validation — Validation des données produit côté client
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

/**
 * Valide les données d'un formulaire produit avant envoi à Firestore.
 * @param {object} form - Le formulaire à valider
 * @returns {{ valid: boolean, error: string|null }}
 */
export function validateProductForm(form) {
  // Nom obligatoire
  if (!form.name || !form.name.trim()) {
    return { valid: false, error: "Le nom du produit est obligatoire." };
  }
  if (form.name.trim().length > 100) {
    return { valid: false, error: "Le nom est trop long (max 100 caractères)." };
  }

  // Quantité obligatoire et numérique
  if (form.qty === "" || form.qty === null || form.qty === undefined) {
    return { valid: false, error: "La quantité est obligatoire." };
  }
  const qty = parseFloat(form.qty);
  if (isNaN(qty) || qty < 0) {
    return { valid: false, error: "La quantité doit être un nombre positif." };
  }
  if (qty > 1000000) {
    return { valid: false, error: "Quantité trop élevée (max 1 000 000)." };
  }

  // Seuil d'alerte
  if (form.alert !== "" && form.alert !== null && form.alert !== undefined) {
    const alert = parseFloat(form.alert);
    if (isNaN(alert) || alert < 0) {
      return { valid: false, error: "Le seuil d'alerte doit être positif." };
    }
  }

  // Prix d'achat
  if (form.price !== "" && form.price !== null && form.price !== undefined) {
    const price = parseFloat(form.price);
    if (isNaN(price) || price < 0) {
      return { valid: false, error: "Le prix d'achat doit être positif." };
    }
    if (price > 100000) {
      return { valid: false, error: "Prix trop élevé (max 100 000 €)." };
    }
  }

  // Prix de vente
  if (form.sellPrice !== "" && form.sellPrice !== null && form.sellPrice !== undefined) {
    const sellPrice = parseFloat(form.sellPrice);
    if (isNaN(sellPrice) || sellPrice < 0) {
      return { valid: false, error: "Le prix de vente doit être positif." };
    }
  }

  // DLC : doit être une date valide (si présente)
  if (form.dlc) {
    const date = new Date(form.dlc);
    if (isNaN(date.getTime())) {
      return { valid: false, error: "Date limite invalide." };
    }
  }

  return { valid: true, error: null };
}
